export default __webpack_public_path__ + "images/third-column-badge-blocked.svg";